export default __webpack_public_path__ + "static/WPS-P2P_09-f6b96a2be57964b9fd851c9a378e4fde.webp";